import React, { createContext, useContext, useState, useCallback } from "react";

interface BreadcrumbContextType {
  detail: string;
  parentPath: string;
  setDetail: (detail: string, parentPath?: string) => void;
  clearDetail: () => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextType>({
  detail: "",
  parentPath: "",
  setDetail: () => {},
  clearDetail: () => {},
});

export const BreadcrumbProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [detail, setDetailState] = useState("");
  const [parentPath, setParentPath] = useState("");

  const setDetail = useCallback((detail: string, parentPath?: string) => {
    setDetailState(detail);
    if (parentPath) setParentPath(parentPath);
  }, []);

  const clearDetail = useCallback(() => {
    setDetailState("");
    setParentPath("");
  }, []);

  return (
    <BreadcrumbContext.Provider value={{ detail, parentPath, setDetail, clearDetail }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumb = () => useContext(BreadcrumbContext);
